import { render, staticRenderFns } from "./LatestReportsNew.vue?vue&type=template&id=692fdee8&scoped=true&"
import script from "./LatestReportsNew.vue?vue&type=script&lang=js&"
export * from "./LatestReportsNew.vue?vue&type=script&lang=js&"
import style0 from "./LatestReportsNew.vue?vue&type=style&index=0&id=692fdee8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "692fdee8",
  null
  
)

export default component.exports